module.exports = __webpack_public_path__ + "static/media/IMG_1272.fdec0edb.jpg";